import { createEpicMiddleware } from 'redux-observable'

import { axios$ } from '../common/utils'
import rootEpics from '../redux/epics'

const dependencies = {
  axios$,
}

const epicMiddleware = createEpicMiddleware({ dependencies })

export const run = () => epicMiddleware.run(rootEpics)

export default epicMiddleware
